import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import {
  $NavActiveDot,
  $NewMenuItemBadge,
} from '../styles/components/MenuLink';
import {
  BadgeType,
  MenuItemBadgeRegistry,
} from '../utils/MenuItemBadgeRegistry';
import { $MenuLink } from '../styles';

const MenuLink = ({ children, icon, isActive, path }) => {
  const indicator = MenuItemBadgeRegistry.getBadge(children);
  const showIndicator = indicator?.shouldShow;
  const showBadge = showIndicator && indicator?.type === BadgeType.Badge;

  return (
    <$MenuLink
      data-cy="menu_link_component"
      $isActive={isActive}
      $isHighlighted={showBadge}
      as={Link}
      to={path}
      onClick={indicator?.shouldShow ? indicator?.onClick : null}
    >
      <div className="title-row">
        <span className="icon">
          <Icon name={icon} />
        </span>
        <span className="label">{children}</span>
        {showIndicator && indicator?.type === 'dot' && <$NavActiveDot />}
        {showBadge && (
          <$NewMenuItemBadge>{indicator?.label || 'NEW'}</$NewMenuItemBadge>
        )}
      </div>
      {showBadge && indicator?.description && (
        <div className="description">{indicator.description}</div>
      )}
    </$MenuLink>
  );
};

MenuLink.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
};

MenuLink.defaultProps = {
  icon: '',
};

export default MenuLink;
